/**
 *
 * @module purchaseManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class PurchaseManagerConfiguration
 * @desc Provides configuration information necessary for managing receipt activation.
 *
 */
export default class PurchaseManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/purchaseManagerConfiguration.js